
<template>
  <div id="mithelfen">
      <PublicMenutop></PublicMenutop>
      <div class="row container" role="main">
        <div class="col">
 
          <h1>Fehler passieren</h1>

          <p>
          Sie haben ein Cover (Bild eines Buchs, DVD, ...) fotografiert 
          und per Whatsapp/Telegram eingesandt.
          Leider konnten wir ihr Bild nicht verwenden, hier finden Sie
          die häufigsten Fehlerursachen.
          </p>

          <h1 style="margin-top:50px">Gutes Bild...</h1>

          <img src="/mitmachen/fehlerfotos/cover_gut.jpg" style="float: left; padding-right: 40px; margin-top: 5px;">
          <h3>Warum es gut ist</h3>
          <ul>
            <li>Von oben fotografiert</li>
            <li>In heller Umgebung fotografiert</li>
            <li>Links, rechts, oben, unten mit Rand</li>
            <li>Kein Blitz benutzt</li>
          </ul>
          <br clear="all">

          <h1 style="margin-top:50px">Typische Bildfehler...</h1>

          <h2>Perspektive: nicht gut</h2>
          <img src="/mitmachen/fehlerfotos/cover_perspektive.jpg" style="float: left; padding-right: 40px; margin-top: 5px;">
          <h3>Fehler</h3>
          <p>Buch schräg fotografiert können wir nicht benutzen.</p>
          <h3>Abhilfe</h3>
          <p>Buch von oben fotografieren</p>
          <br clear="all">

          <h2>Unten breit, oben schmal</h2>
          <img src="/mitmachen/fehlerfotos/cover_untenbreit_obenschmal.jpg" style="float: left; padding-right: 40px; margin-top: 5px;">
          <h3>Fehler</h3>
          <p>Buch schräg fotografiert können wir nicht benutzen.</p>
          <h3>Abhilfe</h3>
          <p>Buch von oben fotografieren</p>
          <br clear="all">

          <h2>Abgeschnitten</h2>
          <img src="/mitmachen/fehlerfotos/cover_abgeschnitten.jpg" style="float: left; padding-right: 40px; margin-top: 5px;">
          <h3>Fehler</h3>
          <p>Buch abgeschnitten können wir nicht benutzen.</p>
          <h3>Abhilfe</h3>
          <p>Buch von oben fotografieren, Rand an allen Seiten lassen.</p>
          <br clear="all">

          <h2>Gedreht</h2>
          <img src="/mitmachen/fehlerfotos/cover_90.jpg" style="float: left; padding-right: 40px; margin-top: 5px;">
          <h3>Fehler</h3>
          <p>Buch 90 Grad gedreht. Wir müssen das Buch mit einem Bildprogramm drehen, bitte 
            helfen Sie uns diesen Aufwandzu vermeiden, das hier ist Freiwilligenarbeit die nicht 
            bezahlt wird.</p>
          <h3>Abhilfe</h3>
          <p>Buch so fotografieren wie einen Menschen, NICHT auf den Kopf stellen</p>
          <br clear="all">

          <h2>Zu wenig Licht</h2>
          <img src="/mitmachen/fehlerfotos/cover_zu_wenig_licht.jpg" style="float: left; padding-right: 40px; margin-top: 5px;">
          <h3>Fehler</h3>
          <p>Buch im Dunkeln fotografiert können wir nicht benutzen. Ihr Handyfoto schaltet auf niedrige Auflösung,
            das Bild wird flau und grieselig.</p>
          <h3>Abhilfe</h3>
          <p>Licht im Zimmer machen, in heller Umgebung fotografieren, NICHT blitzen!</p>
          <br clear="all">
        </div>
      </div>

      
      <Footer></Footer>
  </div>
</template>

<script>
import PublicMenutop from '../../components/public/PublicMenutop.vue';
import Footer from '../../components/Footer.vue';
// kommt von pinegrow/bootstrap4:
import '../../components/sticky-footer-navbar.css';
import axios from 'axios';

// Mixin fuer diese Komponente importieren
import commonvars from '../mixins/commonvars.js';

export default {
  name: 'MithelfenWhatsapp',
  components: {
    PublicMenutop,
    Footer,
  },
  mixins: [
    commonvars
  ],
  data() {
    return {}
  },
  mounted: function() {
      this.statistik_einzelseite_updaten();
  },
  methods: {
    api_statistik_einzelseite_nickname() {
      return 'whatsapp';
    },
    api_statistik_einzelseite_url() {
        return this.server_base_url()
            + '/api/statistik/einzelseite/' + this.api_statistik_einzelseite_nickname();
    },
    statistik_einzelseite_updaten() {
      let url = this.api_statistik_einzelseite_url();

      axios.get(url)
      .then(
          () => {
              console.log("Update Statistik Einzelseite");
              
          }
      )
      .catch(
        () => {
            console.log("Fehler bei Update Statistik Einzelseite");
        }
      );
    }
  }
}

</script>

<style scoped>
a {
   text-decoration: underline;
} 

h2 {
  margin-top: 30px;
}
</style>


